import React, { useEffect, useState } from "react";
import AdminSidebar from './AdminSidebar'
import axios from "axios";
import iziToast from 'izitoast';
import { useAuth } from "../../AuthContext";

const LandingPageQuery = () => {
  const [landingQueryData, setlandingQueryData] = useState([]);
  const { apipath } = useAuth();
  // Function to fetch landingQuery data
  const fetchData = async () => {
    try {
      const response = await axios.get(`${apipath}/landingQuery/get`);
      console.log(response)
      // const response = await axios.get("http://localhost:9090/api/v1/landingQuery/get")
      setlandingQueryData(response.data.allQuery || []);
    } catch (error) {
      console.error('Error fetching enquireNow:', error);
    }
  };

  //  Function to handle landinQuery deletion
  const handleDelete = async (queryId) => {
    try {
      // const response = await axios.delete("http://localhost:9090/api/v1/landingQuery/delete", {
      //   data: { queryId }
      // });
      const response = await axios.delete(`${apipath}/landingQuery/delete`, {
        data: { queryId }
      });
      if (response.status === 200) {
        // Update the state to remove the deleted enquire from the UI
        setlandingQueryData(prevquery => prevquery.filter(query => query._id !== queryId));
        
        // Show success notification
        iziToast.success({
          message: "Query deleted successfully",
          position: "topCenter",
        });
        
      } else {
        // Show error notification if deletion failed
        iziToast.error({
          message: "Query deletion failed",
          position: "topCenter",
        });
      }
    } catch (error) {
      console.error('Error deleting uery:', error);
      // Show error notification if an error occurred
      iziToast.error({
        message: "An error occurred while deleting the Query",
        position: "topCenter",
      });
    }
  };


  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
        <AdminSidebar />
        <div className="home">
        <div className="toggle-sidebar" style={{ display: "none" }}>
          <i className="bi bi-menu"></i>
        </div>
        <div className="dashboard">
          <div className="dashboard-header">
            <h1>Landing Page Query</h1>
          </div>

          <div className="container-fluid">          
          <div className='filter-flex'>
            <div class="input-group search-group">
              <div class="input-group-prepend search-prepend">
                <span class="input-group-text search-text" id="basic-addon1">
                  <i className="bi bi-search"></i>
                </span>
              </div>
              <input
                type="text"
                class="form-control search-control"
                placeholder="Search by name"
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
            </div>
            </div>
            <div className="row foot-tablerow">
              <div className="col-lg-11 maintable-column">
                <div className="container mt-4">
                  <table id="datatable" className="table">
                    <thead>
                      <tr className="tr1">
                      <th>S.No.</th>
                        <th>Name</th>
                        <th>Phone No.</th>
                        <th>Email Id</th>
                        <th>City</th>
                        <th>Product</th>
                        <th>Pieces</th>
                        <th>Date&Time</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {landingQueryData.map((lpQuery, index) => (
                        <tr key={lpQuery._id}>
                        <td>{index + 1}</td>
                          <td>{lpQuery.name}</td>
                          <td>{lpQuery.phoneNo}</td>
                          <td>{lpQuery.email}</td>
                          <td>{lpQuery.address}</td>
                          <td>{lpQuery.product}</td>
                          <td>{lpQuery.pieces}</td>
                          <td>{new Date(lpQuery.createdAt).toLocaleString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          })}</td>
                          <td>
                            <button className="table-btn" onClick={() => handleDelete(lpQuery._id)}>
                              <i className="bi bi-trash"></i>
                            </button>
                        </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPageQuery;
